module.exports = __webpack_public_path__ + "static/media/sublime.8a483f7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/sublime.png
// module id = 198
// module chunks = 0